import { ConflictError } from "./conflict-error";

/**
 * A Personio read on a person's behalf, for a user who has no Personio link. Configuration rather
 * than a bad request: the person connects their account once and every read afterwards works.
 */
export class PersonioNoActiveIntegrationError extends ConflictError {
	constructor() {
		super("integrations.personio_no_active_integration");
		this.name = "PersonioNoActiveIntegrationError";
	}
}

/**
 * A Personio sync of the organisation is already running. Two at once would each find the same
 * people without an account and create every one of them twice. 409: the request is well formed,
 * it is the first run that has not let go yet.
 */
export class PersonioSyncRunningError extends ConflictError {
	constructor() {
		super("integrations.personio_sync.already_running");
		this.name = "PersonioSyncRunningError";
	}
}
